(function () {
  'use strict';

  var C = window.POPUP_QUIZ;
  var root = document.getElementById('quizPopup');
  if (!C || !root || !C.questions || !C.questions.length) return;

  var CFG = window.LEAD_CONFIG || {};
  var PREFIX = CFG.storePrefix || 'clm_pidbir';
  var SEEN_KEY = PREFIX + '_popup_seen';
  var form = root.querySelector('.js-lead-form');
  var answersBox = root.querySelector('.js-qp-answers');
  var i18n = C.i18n || {};

  function alreadyLead() {
    try { return !!sessionStorage.getItem(PREFIX + '_lead_ref'); } catch (e) { return false; }
  }
  function alreadySeen() {
    try { return !!sessionStorage.getItem(SEEN_KEY); } catch (e) { return false; }
  }
  function markSeen() {
    try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
  }

  var answers = {};
  var step = -1;
  var lastFocus = null;
  var isOpen = false;
  var hideT = null;
  var renderedAt = 0;
  var freeMode = false;
  var analyzeT = null;

  var elTitle = root.querySelector('.qp-title');
  var elText = root.querySelector('.qp-text');
  var elBody = root.querySelector('.qp-body');
  var elProgress = root.querySelector('.qp-progress');
  var elBar = root.querySelector('.qp-bar span');
  var elBack = root.querySelector('.qp-back');
  var elLead = root.querySelector('.qp-lead');

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function optionsFor(q) {
    if (!q.byPrev) return q.options || [];
    var prev = answers[q.byPrev];
    var list = (q.map && prev && q.map[prev.code]) || q.fallback || [];
    return list.concat(q.always || []);
  }

  function track(event, extra) {
    if (!window.dataLayer) return;
    window.dataLayer.push(Object.assign({ event: event }, extra || {}));
  }

  function render() {
    renderedAt = Date.now();
    freeMode = false;
    clearTimeout(analyzeT);
    elBody.innerHTML = '';
    elLead.hidden = true;
    elBack.hidden = step <= 0;

    if (step === -1) {
      elProgress.hidden = true;
      elTitle.textContent = C.intro.title;
      elText.textContent = C.intro.text;
      elText.hidden = !C.intro.text;
      var start = el('button', 'btn btn--wide qp-cta', C.intro.cta);
      start.type = 'button';
      start.addEventListener('click', function (e) {
        if (guard()) return;
        track('quiz_popup_start');
        step = 0;
        render();
      });
      elBody.appendChild(start);
      start.focus({ preventScroll: true });
      return;
    }

    if (step < C.questions.length) {
      var q = C.questions[step];
      elProgress.hidden = false;
      elProgress.firstChild.textContent = (i18n.progress || '%1 / %2')
        .replace('%1', step + 1).replace('%2', C.questions.length);
      elBar.style.width = Math.round((step / C.questions.length) * 100) + '%';
      elTitle.textContent = q.q;
      elText.textContent = q.hint || '';
      elText.hidden = !q.hint;

      var list = el('div', 'qp-opts');
      optionsFor(q).forEach(function (o) {
        var b = el('button', 'qp-opt', o.label);
        b.type = 'button';
        if (answers[q.field] && answers[q.field].code === o.code) b.classList.add('is-on');
        b.addEventListener('click', function (e) {
          if (guard()) return;
          if (o.free) { renderFree(q, o); return; }
          answers[q.field] = { code: o.code, label: o.label };
          if (q.field === C.directionField) resetDependent(q.field);
          next();
        });
        list.appendChild(b);
      });
      elBody.appendChild(list);
      var first = list.querySelector('.qp-opt');
      if (first) first.focus({ preventScroll: true });
      return;
    }

    if (step === C.questions.length) {
      elProgress.hidden = false;
      elBar.style.width = '100%';
      elBack.hidden = true;
      elTitle.textContent = C.analyzing.title;
      elText.textContent = '';
      elText.hidden = true;
      var load = el('div', 'qp-load');
      load.innerHTML = '<span></span><span></span><span></span>';
      elBody.appendChild(load);
      elBody.appendChild(el('p', 'qp-load-text', C.analyzing.text));
      elTitle.focus({ preventScroll: true });
      track('quiz_popup_answers_done');
      analyzeT = setTimeout(function () { if (isOpen && step === C.questions.length) { step++; render(); } }, C.analyzing.ms || 1600);
      return;
    }

    elProgress.hidden = true;
    elBack.hidden = true;
    elTitle.textContent = C.finalScreen.title;
    elText.textContent = C.finalScreen.text;
    elText.hidden = false;
    fillLead();
    elLead.hidden = false;
    elTitle.focus({ preventScroll: true });
    var phone = form.querySelector('.js-lf-phone');
    if (phone && window.matchMedia('(min-width: 700px)').matches) phone.focus({ preventScroll: true });
  }

  function resetDependent(field) {
    C.questions.forEach(function (q) {
      if (q.byPrev === field && answers[q.field]) {
        var still = optionsFor(q).some(function (o) { return o.code === answers[q.field].code; });
        if (!still) delete answers[q.field];
      }
    });
  }

  function renderFree(q, o) {
    renderedAt = Date.now();
    freeMode = true;
    elBack.hidden = false;
    elBody.innerHTML = '';
    elText.textContent = o.label;
    elText.hidden = false;
    var wrap = el('div', 'qp-free');
    var ta = document.createElement('textarea');
    ta.className = 'lf-input lf-textarea';
    ta.rows = 3;
    ta.maxLength = 500;
    ta.placeholder = o.placeholder || 'Коротко опишіть вашу ситуацію…';
    ta.value = (answers[q.field] && answers[q.field].code === o.code && answers[q.field].free) || '';
    var go = el('button', 'btn btn--wide qp-cta', i18n.next || 'Далі');
    go.type = 'button';
    go.addEventListener('click', function (e) {
      if (guard()) return;
      var v = ta.value.trim();
      answers[q.field] = { code: o.code, label: v ? o.label + ' — ' + v : o.label, free: v };
      next();
    });
    wrap.appendChild(ta);
    wrap.appendChild(go);
    elBody.appendChild(wrap);
    ta.focus({ preventScroll: true });
  }

  function next() { step++; render(); }

  function guard() {
    return Date.now() - renderedAt < 250;
  }

  elBack.addEventListener('click', function () {
    if (guard()) return;
    if (freeMode) { render(); return; }
    if (step > 0) { step--; render(); }
  });

  function fillLead() {
    if (answersBox) {
      answersBox.innerHTML = '';
      C.questions.forEach(function (q) {
        var a = answers[q.field];
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'q_' + q.field;
        input.value = a ? a.label : '';
        input.setAttribute('data-question', q.q);
        answersBox.appendChild(input);
      });
    }

    var dir = answers[C.directionField];
    var practice = form.querySelector('[name="practice_key"]');
    if (practice) practice.value = dir ? dir.code : '';

    var dirSel = form.querySelector('.js-direction');
    if (dirSel) {
      dirSel.selectedIndex = 0;
      if (dir) {
        var found = false;
        for (var i = 0; i < dirSel.options.length; i++) {
          if (dirSel.options[i].value === dir.label) { dirSel.selectedIndex = i; found = true; break; }
        }
        if (!found) {
          var opt = document.createElement('option');
          opt.value = dir.label; opt.textContent = dir.label;
          dirSel.appendChild(opt);
          dirSel.selectedIndex = dirSel.options.length - 1;
        }
      }
    }
  }

  function open(source) {
    if (isOpen) return;
    isOpen = true;
    stopIdle();
    clearTimeout(hideT);
    lastFocus = document.activeElement;
    root.hidden = false;
    void root.offsetWidth;
    root.classList.add('is-on');
    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('no-scroll');
    markSeen();
    step = -1;
    render();
    track('quiz_popup_open', { popup_trigger: source || 'manual' });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    clearTimeout(analyzeT);
    root.classList.remove('is-on');
    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('no-scroll');
    hideT = setTimeout(function () { root.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    track('quiz_popup_close', { popup_step: step });
  }

  root.querySelectorAll('.js-qp-close').forEach(function (b) { b.addEventListener('click', close); });
  root.addEventListener('click', function (e) { if (e.target === root) close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) close();
  });

  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !isOpen) return;
    var f = root.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select:not([hidden]), textarea');
    var list = [].slice.call(f).filter(function (n) { return n.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  document.querySelectorAll('.js-quiz-open').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); open('button'); });
  });

  var idleMs = Math.max(5, parseInt(C.idleSec, 10) || 30) * 1000;
  var idleT = null;
  var armed = false;
  var lastActivity = 0;
  var ACTIVITY = ['mousemove', 'mousedown', 'keydown', 'scroll', 'wheel', 'touchstart', 'touchmove'];

  function schedule() {
    clearTimeout(idleT);
    if (!armed || document.hidden) return;
    idleT = setTimeout(onIdle, idleMs);
  }

  function onActivity() {
    var now = Date.now();
    if (now - lastActivity < 400) return;
    lastActivity = now;
    schedule();
  }

  function stopIdle() {
    armed = false;
    clearTimeout(idleT);
    ACTIVITY.forEach(function (ev) { window.removeEventListener(ev, onActivity, true); });
    document.removeEventListener('visibilitychange', schedule);
  }

  function onIdle() {
    if (!armed) return;
    if (alreadyLead() || alreadySeen()) { stopIdle(); return; }
    if (document.hidden) return;
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !root.contains(a) && a.value) {
      schedule();
      return;
    }
    open('idle');
  }

  if (alreadySeen() || alreadyLead()) return;
  armed = true;
  ACTIVITY.forEach(function (ev) { window.addEventListener(ev, onActivity, { capture: true, passive: true }); });
  document.addEventListener('visibilitychange', schedule);
  schedule();
})();
